export const getPreviousYearDate = (dateStr?: string | null) => {
  if (!dateStr) return null;

  // Parse the input date string
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return null;

  const targetYear = date.getFullYear() - 1;
  const originalMonth = date.getMonth();
  const originalDay = date.getDate();

  // For Feb 28/29, always use the last valid day of February in the target year.
  if (originalMonth === 1 && (originalDay === 28 || originalDay === 29)) {
    const lastDayOfFebruary = new Date(targetYear, 2, 0).getDate();
    date.setFullYear(targetYear, 1, lastDayOfFebruary);
  } else {
    // Subtract one year from all other dates.
    date.setFullYear(targetYear);
  }

  // Format the date back to the initial format with the correct time
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed, add 1
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
};
